<div>
  @if (label) {
    <span class="font-semibold" data-test-id="service-provider-address-label">{{ label }}</span>
  }
  <span>
    @if (isLoadingProviders) {
      <p-progressSpinner></p-progressSpinner>
    }
  </span>

  <div class="p-form-widget col-span-12 md:col-span-6">
    @if (isAcceptingCare && isExternalUser) {
      <div class="flex gap-2 align-items-center mb-4">
        <label class="label" data-test-id="filter-label"><span class="label"></span>Filter: </label>
        <p-iconfield>
          <p-inputicon class="pi pi-filter" />
          <input
            [ngStyle]="{'width': '19.7rem'}"
            pInputText
            tabindex="1"
            placeholder="Enter a provider name, NPI, or address"
            [(ngModel)]="searchInput"
            (input)="filterChanged($event.target.value)"
            data-test-id="filter-value"
            >
          <p-inputicon class="pi pi-times cursor-pointer" (click)="resetSearch()" data-test-id="filter-reset" />
        </p-iconfield>
      </div>
    }
    </div>

    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <p-listbox
          class="custom-listbox"
          [options]="providersSearch"
          (onClick)="providerListBoxClick($event)"
          data-test-id="provider-listbox"
          >
          <ng-template let-provider let-i="index" pTemplate="item">
            <span
              class="truncate"
              [pTooltip]="provider.value?.npi"
              tooltipPosition="bottom"
              [attr.data-test-id]=" 'provider-address-item' + i + '-label'"
              >{{provider.label}}
            </span>
          </ng-template>
        </p-listbox>
      </div>
    </div>
  </div>
